<template>
    <div>
        <v-navigation-drawer
                absolute
                dark
                v-if="filtersLoaded"
                v-model="showFilter"
        >
            <v-list class="py-0"
                    dense
                    nav
            >
                <v-list-item class="float-md-right">
                    <a @click="toggleFilter">
                        <v-icon>mdi-chevron-double-left</v-icon>
                    </a>
                </v-list-item>
                <v-list-item>
                    <h3>Filters</h3>
                </v-list-item>
                <!--<v-list-item v-if="!locationId">-->
                    <!--<v-text-field-->
                            <!--label="Max Distance"-->
                            <!--type="number"-->
                            <!--v-model="workFilters.miles"-->
                    <!--&gt;</v-text-field>-->
                <!--</v-list-item>-->
            </v-list>
            <div class="filter-label">Category</div>
            <div :key="cat.id" class="filter-check"
                 v-for="cat in categories">
                <v-checkbox :label="cat.name" :value="cat.id"
                            hide-details="true"
                            v-model="workFilters.selectedCategories"></v-checkbox>
            </div>

            <div class="filter-label">Attributes</div>
            <div :key="attr.id" class="filter-check"
                 v-for="attr in attributes">
                <v-checkbox :label="attr.name" :value="attr.id"
                            hide-details="true"
                            v-model="workFilters.selectedAttributes"></v-checkbox>
            </div>

            <div v-bind:style="{ 'margin-bottom': '100px' }">
                <v-btn small class="mt-5 ml-5 mr-5 mb-4" @click="applyFilters">Apply Filters</v-btn>
                <v-btn small class="ml-5 mr-5 mb-4" @click="clearFilters">Clear All</v-btn>
                <v-btn small class="ml-5 yellow white--text" @click="saveFilters">Save Filters</v-btn>
            </div>

        </v-navigation-drawer>
    </div>

</template>

<script>
    import api from "../services/aggrega8-api";
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: 'FarmLogixFilter',  //<filter> is a reserved HTML element
        props: {
            locationId: {
                type: String,
                default: null
            }
        },
        computed: {
            selectedProgram: function () {
                return this.$store.state.selectedProgram
            },
            showFilter: {
                get() {
                    return this.$store.state.filters.showFilter;
                },
                set(val) {
                    this.$store.commit('SET_FILTER_VISIBLE', val);
                }
            },
            miles: {
                get() {
                    return this.$store.state.pickupFilters.miles;
                }
            },
            pickupDate: {
                get() {
                    return this.$store.state.pickupFilters.date;
                }
            },
            pickupTime: {
                get() {
                    return this.$store.state.pickupFilters.time;
                }
            },
            pickupLocation: {
                get() {
                    return this.$store.state.pickupFilters.pickupLocation;
                }
            },
            vendor: {
                get() {
                    return this.$store.state.pickupFilters.vendor;
                }
            },
            categories: {
                get() {
                    return this.$store.state.filters.categories;
                },
                set(val) {
                    this.$store.commit('SET_FILTER_CATEGORIES', val);
                }
            },
            attributes: {
                get() {
                    return this.$store.state.filters.attributes;
                },
                set(val) {
                    this.$store.commit('SET_FILTER_ATTRIBUTES', val);
                }
            },
            selectedCategories: {
                get() {
                    return this.$store.state.filters.selectedCategories;
                },
                set(val) {
                    this.$store.commit('SET_FILTER_SELECTED_CATEGORIES', val);
                }
            },
            selectedAttributes: {
                get() {
                    return this.$store.state.filters.selectedAttributes;
                },
                set(val) {
                    this.$store.commit('SET_FILTER_SELECTED_ATTRIBUTES', val);
                }
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            },
            userDetails: function () {
                return this.$store.state.userDetails
            }
        },
        data: () => ({
            filtersLoaded: false,
            workFilters: {
                // miles: null,
                selectedCategories: [],
                selectedAttributes: []
            }
        }),
        mounted() {
            window.scrollTo(0, 0);

            this.loadOptions();
            this.workFilters.selectedCategories = _.clone(this.selectedCategories);
            this.workFilters.selectedAttributes = _.clone(this.selectedAttributes);
        },
        methods: {
            loadOptions() {
                this.$store.dispatch("setExecuting", true);
                let searchParams = new URLSearchParams();

                if(this.miles)
                    searchParams.append('miles', this.miles);

                if(this.city)
                    searchParams.append('city', this.city);

                if(this.state)
                    searchParams.append('state', this.state);

                if(this.zipCode)
                    searchParams.append('zipCode', this.zipCode);

                if(this.pickupDate)
                    searchParams.append('pickupDate', moment.utc(this.pickupDate).format('YYYY-MM-DD'));

                if(this.pickupTime)
                    searchParams.append('pickupTime', moment.utc(this.pickupTime).format('HH:mm'));

                if(this.pickupLocation && !this.vendor)
                    searchParams.append('pickupLocation', this.pickupLocation);

                if(this.vendor)
                    searchParams.append('vendor', this.vendor);

                api.get('/consumer/filterValues', {params: searchParams}).then(
                    (results) => {
                        this.attributes = results.data.attributes;
                        this.categories = results.data.categories;
                        let validCategories = results.data.categories.map(x => x.id)
                        let validAttributes = results.data.attributes.map(x => x.id)

                        if (!this.locationId)
                        {
                            api.get('/consumer/filterPreferences').then(
                                (results) => {
                                    results.data.categories.forEach((catId) => {
                                        if(validCategories.includes(catId))
                                            this.workFilters.selectedCategories.push(catId)
                                    });
                                    results.data.attributes.forEach((attrId) => {
                                        if(validAttributes.includes(attrId))
                                            this.workFilters.selectedAttributes.push(attrId)
                                    });

                                    if (this.workFilters.selectedCategories || this.workFilters.selectedAttributes) {
                                        this.applyFilters();
                                    }
                                }).then(() => {
                                this.$store.dispatch("setExecuting", false)
                            })
                        }

                        this.filtersLoaded = true
                    }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },
            toggleFilter() {
                this.$store.dispatch("toggleFilter")
            },
            applyFilters() {
                this.showFilter = false;
                this.selectedCategories = this.workFilters.selectedCategories;
                this.selectedAttributes = this.workFilters.selectedAttributes;
                // this.miles = this.workFilters.miles;
                this.$emit("applyFilters");
            },
            clearFilters() {
                this.workFilters.selectedCategories = [];
                this.workFilters.selectedAttributes = [];
                // this.workFilters.miles = 25;
                this.applyFilters();
            },
            saveFilters() {
                api.post('/consumer/filterPreferences', {
                    filterPreferences: {
                        categories: this.workFilters.selectedCategories,
                        attributes: this.workFilters.selectedAttributes
                    }
                    }).then(() => {
                        this.$store.dispatch("setExecuting", false)
                        this.applyFilters();
                    })
            }
        }
    }
</script>

<style scoped>
    .filter-label {
        color: rgba(255, 255, 255, 0.7);
        padding-left: 15px;
        font-weight: bold;
    }

    .filter-check {
        padding-left: 25px;
    }

    .filter-check > .v-input--selection-controls {
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
</style>
